const device = {
//    mobile: '(max-width: 480px)'
    mobile: '(max-width: 640px)'
}

export default device;